module.exports = __webpack_public_path__ + "img/solmu.276a4653.webp";